/**
 * 
 * @module http/autoCDM 操作autoCDM数据的http模块  
 */

import { taskUtils } from "@/ref/autocdm/utils.js";
import axios from '../axios';
import global from '@/utils/global';


/**
 *取autocdm项目/工程数据
 *
 * @function
 * @param {object} params projectid项目id projecttype项目类型,比如road，house
 * @return {promise}  模型数据和属性数据
 */
export function getAutoCDMData(params) {//{'projectid':'111'}
    let type = params.projecttype;
    let promise, url, post = {};
    if (type == "Eroad") {
        url = "/autocdm/bdm/getRoadById";
        post.eid = params.projectid;
        promise = axios({
            baseUrl: global.autoCDMUrl.building,
            url: url,
            method: 'get',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json;charset=UTF-8' },
            params: post
        });
    } else if (type == "Ebridge") {
        url = "/autocdm/bdm/bridge/getPierByEidList";
        post.eidList = [params.projectid];
        promise = axios({
            baseUrl: global.autoCDMUrl.building,
            url: url,
            method: 'post',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json;charset=UTF-8' },
            data: post
        });
    } else if (type == "Etunnel") {
        url = "/autocdm/bdm/tunnel/getTunnelLocation";
        post.eidList = [params.projectid];
        promise = axios({
            baseUrl: global.autoCDMUrl.building,
            url: url,
            method: 'post',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json;charset=UTF-8' },
            data: post
        });
    } else if (type == "imported") {
        url = '/autocdm/bdm/getImportModelByProjectId';
        post.projectId = params.projectid;
        promise = axios({
            baseUrl: global.autoCDMUrl.building,
            url: url,
            method: 'get',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json;charset=UTF-8' },
            responseType: 'json',
            params: post
        });
    } else {//默认
        url = '/autocdm/bdm/axisnet/getallcompgeometry';
        post.projectid = params.projectid;
        promise = axios({
            baseUrl: global.autoCDMUrl.building,
            url: url,
            method: 'get',
            headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/octet-stream' },
            responseType: 'blob',
            params: post
        });
    }

    return promise;
};

/**
 *
 *取当前用户的所有项目
 * @export
 * @param {string} accountid 用户Id
 * @return {promise} 
 */
export function getAutoCDMProjects(accountid) {
    let urll = '/bdm/checkAndInitDemoProject';
    let params = { "accountid": accountid };
    return axios({
        baseUrl: global.autoCDMUrl.building,
        url: urll,
        method: 'get',
        params
    })
};

/**
 *
 *取当前用户的所有项目
 * @export
 * @param {string} projectid 项目id
 * @return {promise} 
 */
export function getAutoCDMSubProjects(projectid) {
    let urll = '/autocdm/bdm/getEngineeringByProjectid';
    let params = { projectid: projectid };
    return axios({
        baseUrl: global.autoCDMUrl.building,
        url: urll,
        method: 'get',
        params
    })
};

/**
 *取当前项目的甘特图数据
 *
 * @export
 * @param {string} projectid
 * @return {promise} 
 */
export function findByProjectId(projectid) {
    let urll = '/tbimGanttTasks/findByProjectId';
    let params = { projectid: projectid };
    return axios({
        //baseUrl: global.autoCDMUrl.building,
        url: urll,
        method: 'get',
        params
    })
};



// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/tbimGanttTasks/findPage',
        method: 'post',
        data
    })
};
/**
 * 
 */


/**
 *
 *更新一条任务内容
 * @param {object} task 
 * @return {promise} 
 */
export function update(data) {
    data = Object.assign({}, data);
    taskUtils.toServer(data);
    return axios({
        url: '/tbimGanttTasks/update',
        method: 'post',
        data
    })
}

/**
 *批量更新任务的日期
 *
 * @export
 * @param {array} tasks  包括id,start_date,end_date,duration,actual_start_date,actual_end_date,tasktype
 * @return {promise} 
 */
export function batchupdate(datas) {
    datas.forEach(function (d) {
        taskUtils.toServer(d);
    });
    return axios({
        url: '/tbimGanttTasks/batchupdate',
        method: 'post',
        data: datas
    })
}

/**
 *保存一条任务
 *
 * @export
 * @param {object} task
 * @return {promise} 
 */
export function save(data) {
    data = Object.assign({}, data);
    taskUtils.toServer(data);
    return axios({
        url: '/tbimGanttTasks/save',
        method: 'post',
        data
    })
}

/**
 *自动生成任务时，替换旧任务，批量新增新任务
 *
 * @export
 * @param {array} tasks
 * @return {promise} 
 */
export function replacebatchsave(datas) {
    datas.forEach(function (d) {
        taskUtils.toServer(d);
    });
    return axios({
        url: '/tbimGanttTasks/replacebatchsave',
        method: 'post',
        data: datas
    })
}

/**
 *批量新增任务
 *
 * @export
 * @param {array} tasks 
 * @return {promise} 
 */
export function batchsave(datas) {
    datas.forEach(function (d) {
        taskUtils.toServer(d);
    });
    return axios({
        url: '/tbimGanttTasks/batchsave',
        method: 'post',
        data: datas
    })
}

/**
 *批量删除任务
 *
 * @export
 * @param {array} tasks  数组中是{id: seledTaskid}
 * @return {promise} 
 */
export function batchDelete(data) {
    data.forEach(function (d) {
        taskUtils.toServer(d);
    });
    return axios({
        url: '/tbimGanttTasks/delete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/autoCDM.js